import React, { FC, useMemo } from 'react';
import { ContentGrid } from '@shared-tracpage/components/content-grid';
import { HomeWrapperItems } from '@shared-tracpage/components/home-wrapper-items';
import { List } from '@shared-tracpage/components/list';
import { MerchProduct } from '@services/merch/types/api/merch-product';
import { connect } from 'react-redux';
import AppState from '@webapp/store/state';
import { ProductItemAlt } from '@shared-tracpage/components/product-item-alt';
import { groupMerchByVisibility } from '@shared-tracpage/utils/group-by-visibility';
import TracPage from '@services/tracpage/types/trac-page';
import { ProductList } from '@shared-tracpage/components/product-list';

type StateProps = {
  pageData: TracPage;
  merch: MerchProduct[];
};
type Props = StateProps;

const mapStateToProps = (state: AppState): StateProps => ({
  merch: state.merch.artistMerch,
  pageData: state.tracpage.artistPageDraft,
});

const MerchPage: FC<Props> = ({ merch, pageData }) => {
  const { visible, hidden } = useMemo(
    () => groupMerchByVisibility(merch, pageData),
    [merch, pageData]
  );

  return (
    <>
      <HomeWrapperItems>
        {/* @ts-expect-error */}
        <ProductList products={visible} siteData={pageData} />
        {!!hidden.length && (
          <ContentGrid noEditUI title="Hidden Products">
            <List gap="small">
              {hidden.map((m) => (
                <ProductItemAlt noReorder hidden key={m.id} product={m} />
              ))}
            </List>
          </ContentGrid>
        )}
      </HomeWrapperItems>
    </>
  );
};

export default connect(mapStateToProps)(MerchPage);
